export class DoubleSelector {
  constructor(form) {
    this.capacityValue = form.querySelector('.js-unit-capacity-value').value.replace(',', '.');
    this.inputQuantity = form.querySelector('.js-quantity__input');
    this.quantityButtons = form.querySelectorAll('.js-quantity__buttons');
    this.inputCapacity = form.querySelector('.js-unit-capacity__input');

    // use to break the reference with inputQuantity.value which is also used by integration-web-core--socle JS
    this.result = parseInt(this.inputQuantity.value);

    // init inputCapacity
    this.updateCapacity();

    // watch change on quantity input
    this.inputQuantity.addEventListener('keyup', () => {
      this.inputQuantity.value = this.inputQuantity.value.replace(/[^0-9]/g, '');
      this.updateCapacity();
    });
    this.inputQuantity.addEventListener('QUANTITY_UPDATED', () => {
      this.inputQuantity.value = this.inputQuantity.value.replace(/[^0-9]/g, '');
      this.updateCapacity();
    });

    // watch change on capacity input
    this.inputCapacity.addEventListener('keyup', () => {
      this.inputCapacity.value = this.inputCapacity.value.replace(/[^0-9,.]/g, '');
      this.updateQuantity();
    });

    // update capacity on click on quantity buttons (plus and minus)
    this.quantityButtons.forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(() => this.inputCapacity.value = Math.round(parseInt(this.inputQuantity.value) * this.capacityValue * 100) / 100, 25);
      });
    });
  }

  /**
   * updateCapacity : update the capacity when quantity change
   */
  updateCapacity() {
    try {
      this.inputQuantity.value = this.inputQuantity.value.replace(',', '.');
      this.inputCapacity.value = this.inputQuantity.value * this.capacityValue;
      this.inputCapacity.value = Math.round(this.inputCapacity.value * 100) / 100;
      this.result = parseInt(this.inputQuantity.value);
      this.updateButtons();
    } catch (error) {
      console.error('Error on updateQuantity', error);
    }
  }

  /**
   * updateQuantity : update the quantity when capacity change
   */
  updateQuantity() {
    try {
      this.inputCapacity.value = this.inputCapacity.value.replace(',', '.');
      this.inputQuantity.value = Math.ceil(this.inputCapacity.value / this.capacityValue);
      this.result = parseInt(this.inputQuantity.value);
      this.updateButtons();
    } catch (error) {
      console.error('Error on updateCapacity', error);
    }
  }
  updateButtons() {
    this.quantityButtons.forEach(button => {
      if (button.classList.contains("js-quantity__button-minus")) {
        button.disabled = this.inputQuantity.value <= 1;
      }
    });
  }
}